import { Input, OnDestroy } from "@angular/core";
import { Component } from "@angular/core";
import * as Models from "../../service-charges.model";
import { ServiceService } from "../../chargeser.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "src/app/_services/notifier.service";
import { of, Subject, Subscription, timer } from "rxjs";
import { take } from "rxjs/internal/operators/take";
import { SimpleChanges } from "@angular/core";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { map, switchMap, takeWhile } from "rxjs/operators";
import { MonthlyExpandService } from "../../../monthlybilling.service";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { ExportService, ExportReport, StatusPayload, StartExportPayload } from "../../export.service";

@Component({
  selector: "monthly-component",
  templateUrl: "./monthly.component.html",
  styleUrls: ["./monthly.component.css"],
})
export class MonthlyComponent implements OnDestroy {
  //   @ViewChild(FilterByTagsComponent) filterComponent!: FilterByTagsComponent;
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;
  @Input() isExpandedAll: any;
  market_isExpandedAll: any;
  @Output() monthlyData = new EventEmitter<{
    services: any[];
    prevMonth: any[];
    total: number;
    totser: number;
  }>();
  @Input() filteredTag: any;
  market_filteredTag: any;
  @Input() searchTerm: any;
  market_searchTerm: any;
  accountOptions: { id: number; name: string }[] = [];
  private generateTriggered = false;
private staleSignature: string | null = null; // identifies the old report during regenerate

  selectedAccountIds: any = [];

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  graph_curr: any = [];
  graph_prev: any = [];
  market_prevMonth: any = [];

  gear: boolean = false;
  currentPage = 1;
  market_currentPage = 1;
  pageSizeOptions = [20, 50, 100];

  filterTags = false;

  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];
  prevMonth: any = [];
  services: Models.Service[] = [];
  sortKey: Models.SortableColumn = "product_code";
  // searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  total: any;
  totactiveser: any = 0;
  filteredList: Models.Service[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  // filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
  //   null;
  selectedPageSize = 20;
  market_selectedPageSize = 20;
  usagePagination = false;
  market_preferencesData: "No";
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 20,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };
  chartInstance: any;
  selectedView: any = "monthly";
  market_total: any;
  market_totactiveser: any;
  market_services: any;
  market_filteredList: any[];
  activeBreakpoints: any;

  // ---------- Export state ----------
  showExportModal = false;
  exportStarting = false;
  exportReport: ExportReport | null = null;
  exportError = "";
  exportElapsed = "";
  private exportPoll?: Subscription;
  private elapsedTimer?: Subscription;
  private exportStartedAtMs = 0;

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private monthexp: MonthlyExpandService,
    private exportSvc: ExportService,
  ) {}

  ngOnInit(): void {
    this.preferencesData.selectedAccountIds.push(this.accountId);
    this.funRef = {};

    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((p): void => {
        const { open, _t, ...fp } = p;
        const b =
          p["breakup"]
            ?.toString()
            .split(",")
            .map((x: any) => x.trim())
            .filter(Boolean) || [];
        const allKeys: (keyof typeof this.preferencesData.breakpoints)[] = [
          "region",
          "product_family",
          "line_item",
        ];

        if (p["tag_key"] && p["tag_value"] && b.length) {
          // set breakpoints
          this.preferencesData.breakpoints = {
            ...this.preferencesData.breakpoints,
            ...b.reduce((acc: any, k: string) => ((acc[k] = true), acc), {}),
          };
          this.filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.market_filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.loadPreferences(fp);
          return;
        }

        if ("mode" in p) {
          allKeys.forEach(
            (k) => (this.preferencesData.breakpoints[k] = b.includes(k)),
          );
          this.loadPreferences(fp);
          return;
        }

        if (!("open" in p)) {
          this.load();
          return;
        }

        setTimeout(
          () => this.loadPreferences({ ...fp, account_ids: this.accountId }),
          100,
        );
      });
    } else {
      this.load();
    }
  }

  toggleExpandAll() {
    this.monthexp.toggleExpandRecursive(this.services, !this.isExpandedAll);
    this.isExpandedAll = !this.isExpandedAll;
    this.services.forEach(
      (s) => (this.productNameExpandedMap[s.product_code] = this.isExpandedAll),
    );
  }

  market_toggleExpandAll() {
    const newState = !this.market_isExpandedAll;
    this.monthexp.toggleExpandRecursive(this.market_services, newState);

    this.market_services.forEach((s: any) => {
      this.productNameExpandedMap[s.product_code] = newState;
    });

    this.market_isExpandedAll = newState;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();

    this.preferencesData = this.getDefaultPreferences();

    if (changes["filteredTag"] && this.filteredTag) {
      this.onTagsFiltered(this.filteredTag);
    }

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.filteredTag = null;
      this.clearExport();
      this.load(); // call API only when monthYear or accountId changes
    }

    if (changes["searchTerm"] || changes["tableData"]) {
      this.onSearch();
    }

    if (changes["isExpandedAll"] && !changes["isExpandedAll"].isFirstChange()) {
      // Expand all
      if (this.isExpandedAll) {
        this.monthexp.toggleExpandRecursive(this.services, true);
      } else {
        this.monthexp.toggleExpandRecursive(this.services, false);
      }

      // Collapse all
    }
  }

  handlePageSizeChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
    this.market_selectedPageSize = newPageSize;
    this.currentPage = 1; // reset page
    this.market_currentPage = 1;
  }

  private async fetchAndBind(
    query: Record<string, any>,
    pushToUrl = true,
  ): Promise<void> {
    this.notifier.loading(true);

    try {
      // Decide query based on selected view
      const apiQuery = {
        ...query,
        type: this.selectedView, // 'daily', 'weekly', or 'monthly'
      };

      await this.loadViewData(apiQuery, pushToUrl);
    } catch (err) {
      // fallback if API fails
      this.total = this.totactiveser = 0;
      this.services = this.filteredList = [];
      this.market_services = this.market_filteredList = [];
      this.prevMonth = [];
    } finally {
      this.notifier.loading(false);
    }
  }

  private async loadViewData(
    query: Record<string, any>,
    pushToUrl = true,
  ): Promise<void> {
    const { result, fullQuery } = await this.service.loadData(query);

    const periodKey =
      this.selectedView === "daily"
        ? "current_day"
        : this.selectedView === "weekly"
          ? "current_week"
          : "current_month";

    const accounts = result?.response?.aws[0]?.[periodKey] ?? [];
    const market = result?.response?.marketplace[0]?.[periodKey] ?? [];

    this.total = accounts[0]?.final_cost ?? 0;
    this.totactiveser = accounts[0]?.aws_services ?? 0;

    this.services = accounts.flatMap((acc: any) =>
      (acc.services ?? []).map((s: any) => ({
        ...s,
        expanded: false,
      })),
    );

    this.filteredList = [...this.services];

    this.market_total = market[0]?.final_cost ?? 0;
    this.market_totactiveser = market[0]?.market_place_services ?? 0;

    this.market_services = market.flatMap((acc: any) =>
      (acc.services ?? []).map((s: any) => ({
        ...s,
        expanded: false,
      })),
    );

    this.market_filteredList = [...this.market_services];

    const prevKey =
      this.selectedView === "daily"
        ? "previous_day"
        : this.selectedView === "weekly"
          ? "previous_week"
          : "previous_month";

    const prevAccounts = result?.response?.aws[0]?.[prevKey] ?? [];
    this.prevMonth = prevAccounts.flatMap((acc: any) =>
      (acc.services ?? []).map((s: any) => ({
        ...s,
        expanded: false,
      })),
    );

    this.market_prevMonth =
      result?.response?.marketplace[0]?.previous_month[0]?.final_cost ?? 0;

    if (pushToUrl && fullQuery) {
      const params: any = {};
      fullQuery.split("&").forEach((pair: string) => {
        const [key, value] = pair.split("=");
        if (key && value !== undefined) params[key] = value;
      });
      params["_t"] = Date.now();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        replaceUrl: true,
      });
    }

    this.graph_curr = [
      ...this.services,
      { product_code: "AWS marketplace", final_cost: this.market_total },
    ];

    this.graph_prev = [
      ...this.prevMonth,
      { product_code: "AWS marketplace", final_cost: this.market_prevMonth },
    ];

    this.monthlyData.emit({
      services: this.services,
      prevMonth: this.prevMonth,
      total: this.total,
      totser: this.totactiveser,
    });
  }

  private baseParams(accountIds: string | string[]): Record<string, any> {
    const [month, year] = this.monthYear.split("-");
    return { account_ids: accountIds, year, month };
  }

  async loadPreferences(filteredQuery: any): Promise<void> {
    this.filteredTag =
      filteredQuery?.tag_key && filteredQuery?.tag_value
        ? {
            accountId: filteredQuery.account_ids,
            tagKey: filteredQuery.tag_key,
            tagValue: filteredQuery.tag_value,
          }
        : null;
    const { mode, ...queryWithoutMode } = filteredQuery;

    await this.fetchAndBind(queryWithoutMode);

    if (mode) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { mode },
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
    }
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyFilter(term));
    this.filteredList = [...this.services];

    this.marketSearchSubscription = this.marketSearchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyMarketFilter(term));
    this.market_filteredList = [...this.market_services];
  }

  async load(): Promise<void> {
    const params = this.baseParams(this.accountId);
    if (this.filteredTag?.tagKey && this.filteredTag?.tagValue) {
      Object.assign(params, {
        tag_key: this.filteredTag.tagKey,
        tag_value: this.filteredTag.tagValue,
        breakup: Object.entries(this.preferencesData.breakpoints)
          .filter(([, v]) => v)
          .map(([k]) => k)
          .join(","),
        account_ids: this.filteredTag.accountId,
      });
    }
    params["type"] = this.selectedView;
    await this.fetchAndBind(params);
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyFilter(term));
    this.filteredList = [...this.services];

    this.marketSearchSubscription = this.marketSearchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyMarketFilter(term));
    this.market_filteredList = [...this.market_services];
    // this.loadChart();
  }

  market_onSearch() {
    this.marketSearchSubject.next(this.market_searchTerm);
  }

  handlePreferencesResponse(data: any) {
    this.gear = false;
    this.isExpandedAll = false;
    if (data.preferences) {
      this.preferencesData = data.preferences;
      this.usagePagination = data.preferences.usagePagination;
      this.breakpoints = data.preferences.breakpoints;
      this.selectedAccountIds = data.preferences.selectedAccountIds;
    } else {
      console.log("No preferences found in response");
    }

    if (data.services) {
      this.services = data.services;
      this.monthexp.addExpandedFlag(data.services || []);
      this.filteredList = [...this.services];
      this.market_filteredList = [...this.market_services];
    } else {
      this.activeBreakpoints = Object.keys(
        data.preferences?.breakpoints ?? {},
      ).filter((key) => data.preferences.breakpoints[key]);

      if (data.preferences?.breakpointsChanged) {
        let params: Record<string, any> = {
          ...this.baseParams(this.accountId),
        };

        if (this.activeBreakpoints.length > 0) {
          params = {
            ...params,
            mode: "preferences",
            breakup: this.activeBreakpoints,
          };
        } else {
          const { mode, breakup, ...rest } = params;
          params = rest;
        }

        this.fetchAndBind(params);
      } else {
        console.log("No services found in response");
      }
    }

    if (data.current_month) {
      this.total = data.current_month[0].final_cost;
    } else {
      console.log("No current_month data found in response");
    }

    if (this.filteredTag) {
      this.load();
    } else {
      console.log("No filtered tag, skipping load()");
    }

    this.currentPage = 1;
    this.market_currentPage = 1;
  }

  async onTagsFiltered({
    accountId,
    tagKey,
    tagValue,
  }: {
    accountId: any;
    tagKey: string;
    tagValue: string;
  }): Promise<void> {
    this.isExpandedAll = false;
    this.filteredTag = { accountId, tagKey, tagValue };
    this.preferencesData = this.getDefaultPreferences(accountId);
    // a new filter makes any previous export irrelevant
    this.clearExport();

    const params = {
      ...this.baseParams(accountId),
      tag_key: tagKey,
      tag_value: tagValue,
      mode: "filter",
    };
    await this.fetchAndBind(params);
  }

  get paginatedList() {
    return this.monthexp.paginate(
      this.filteredList,
      this.currentPage,
      this.selectedPageSize,
    );
  }

  get totalPages() {
    return this.monthexp.totalPages(this.filteredList, this.selectedPageSize);
  }

  goToNextPage() {
    this.currentPage = this.monthexp.nextPage(
      this.currentPage,
      this.totalPages,
    );
  }

  goToPreviousPage() {
    this.currentPage = this.monthexp.prevPage(this.currentPage);
  }

  get marketPaginatedList() {
    return this.monthexp.paginate(
      this.market_filteredList,
      this.market_currentPage,
      this.market_selectedPageSize,
    );
  }

  get marketTotalPages() {
    return this.monthexp.totalPages(
      this.market_filteredList,
      this.market_selectedPageSize,
    );
  }

  marketNext() {
    this.market_currentPage = this.monthexp.nextPage(
      this.market_currentPage,
      this.marketTotalPages,
    );
  }

  marketPrev() {
    this.market_currentPage = this.monthexp.prevPage(this.market_currentPage);
  }

  clearTagFilter() {
    this.filteredTag = null;
    this.clearExport();
    this.preferencesData = this.getDefaultPreferences();
    this.load();
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  marketSearchSubject: Subject<string> = new Subject<string>();
  marketSearchSubscription!: Subscription;

  onSearch() {
    this.searchSubject.next(this.searchTerm);
  }

  applyFilter(searchText: string) {
    const filterText = searchText.trim().toLowerCase();

    if (!filterText) {
      this.filteredList = [...this.services];
      return;
    }

    this.filteredList = this.services.filter(
      (service) =>
        (service.product_code || "").toLowerCase().includes(filterText) ||
        (service.product_name || "").toLowerCase().includes(filterText),
    );
  }

  applyMarketFilter(searchText: string) {
    const filterText = searchText.trim().toLowerCase();

    if (!filterText) {
      this.market_filteredList = [...this.market_services];
      return;
    }

    this.market_filteredList = this.market_services.filter(
      (service: any) =>
        (service.product_name || "").toLowerCase().includes(filterText) ||
        (service.product_code || "").toLowerCase().includes(filterText) ||
        (service.region || "").toLowerCase().includes(filterText),
    );
  }

  // Track which product_name rows are expanded
  productNameExpandedMap: { [key: string]: boolean } = {};

  toggleProductName(product: Models.Service) {
    const isNowExpanded = !this.productNameExpandedMap[product.product_code];
    this.productNameExpandedMap[product.product_code] = isNowExpanded;

    if (!isNowExpanded) {
      product.expanded = false;
    }
  }

  // Helper function to check expanded state
  isProductNameExpanded(service: Models.Service): boolean {
    return !!this.productNameExpandedMap[service.product_code];
  }

  trackByProductCode(index: number, item: Models.Service): string {
    return item.product_code;
  }

  private getDefaultPreferences(accountIds: any[] = []): any {
    return {
      pageSize: 20,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: accountIds,
    };
  }

  onViewChange() {
    this.load();
  }

  get exportStatus(): string {
    return (this.exportReport?.status || "").toUpperCase();
  }

  get exportStatusText(): string {
    if (this.exportStarting && !this.exportReport) return "Process initiated";
    switch (this.exportStatus) {
      case "PENDING":
        return "Export queued";
      case "COMPLETED":
        return "Export completed";
      case "FAILED":
        return this.exportError || "Export failed";
      default:
        return this.exportReport
          ? `Generating report (${this.exportStatus})`
          : "";
    }
  }

  /** Download link, only when the report is completed */
  get exportLink(): string {
    return this.exportStatus === "COMPLETED"
      ? this.exportReport?.url || ""
      : "";
  }

  // same approach as downloadReport() in consolidated-ec2-report
  downloadExport(): void {
    const url = this.exportLink;
    if (!url) return;
    const a = document.createElement("a");
    a.download = url;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  get exportRunning(): boolean {
    if (this.exportStarting) return true;
    if (!this.exportReport) return false;
    return this.isRunningStatus(this.exportReport.status);
  }

  /** Real progress if backend sends it, otherwise full bar (animated while running) */
  get exportProgress(): number {
    const p = this.exportReport?.progress;
    if (typeof p === "number") return Math.max(0, Math.min(100, p));
    return 100;
  }

  get exportHasRealProgress(): boolean {
    return typeof this.exportReport?.progress === "number";
  }

/** Normal export: check status first, generate only if NOT_FOUND */
startExport(): void {
  if (!this.filteredTag || this.exportRunning) return;
  this.beginExport(null);
  this.generateTriggered = false;
  this.pollExport();
}

/** Regenerate: always call generate (overwrite: true), then poll status */
regenerateExport(): void {
  if (!this.filteredTag || this.exportRunning) return;

  // remember the old report so it isn't mistaken for the new one
  const old = this.exportReport;
  const signature = old
    ? `${old.status}|${old.started_at}|${old.completed_at}`
    : null;

  this.beginExport(signature);
  this.generateTriggered = true;

  this.exportSvc.start(this.buildGeneratePayload()).subscribe({
    next: () => this.pollExport(),
    error: () => this.failExport("Could not start export. Please try again."),
  });
}

private beginExport(staleSignature: string | null): void {
  this.clearExport();
  this.staleSignature = staleSignature;
  this.exportStarting = true;
  this.showExportModal = true;
  this.exportStartedAtMs = Date.now();
  this.startElapsedTimer();
}

private buildGeneratePayload(): StartExportPayload {
  const [month, year] = this.monthYear.split("-");
  const tag = this.filteredTag;
  return {
    account_ids: tag.accountId,
    year,
    month,
    tag_key: tag.tagKey,
    tag_value: tag.tagValue || "",
  };
}

private buildStatusPayload(): StatusPayload {
  const [month, year] = this.monthYear.split("-");
  const tag = this.filteredTag;
  return {
    account_ids: tag.accountId,
    year,
    month,
    tag_key: tag.tagKey,
    tag_value: tag.tagValue || "ALL",
  };
}

private pollExport(): void {
  if (!this.filteredTag) return;
  const statusPayload = this.buildStatusPayload();
  const generatePayload = this.buildGeneratePayload();

  this.exportPoll?.unsubscribe();
  this.exportPoll = timer(0, 10000)
    .pipe(
      switchMap(() => this.exportSvc.getStatus(statusPayload)),

      // ignore the old report right after Regenerate
      map((report): ExportReport => {
        if (this.staleSignature) {
          const sig = `${report.status}|${report.started_at}|${report.completed_at}`;
          if (sig === this.staleSignature) return { status: "PENDING" };
          this.staleSignature = null; // new report arrived
        }
        return report;
      }),

      // NOT_FOUND -> generate once, show as queued
      switchMap((report) => {
        if (
          report.status?.toUpperCase() === "NOT_FOUND" &&
          !this.generateTriggered
        ) {
          this.generateTriggered = true;
          return this.exportSvc
            .start(generatePayload)
            .pipe(map(() => ({ status: "PENDING" }) as ExportReport));
        }
        return of(report);
      }),

      takeWhile((r) => this.isRunningStatus(r?.status), true),
    )
    .subscribe({
      next: (report) => {
        this.exportStarting = false;
        this.exportReport = report;
        if (!this.isRunningStatus(report.status)) {
          this.stopElapsedTimer();
          if (this.exportStatus === "FAILED") {
            this.exportError = report.error || "Export failed.";
          }
        }
      },
      error: () =>
        this.failExport("Could not get export status. Please try again."),
    });
}

private failExport(msg: string): void {
  this.exportStarting = false;
  this.stopElapsedTimer();
  this.exportError = msg;
}

  openExportModal(): void {
    this.showExportModal = true;
  }

  /** Hides the popup; polling keeps running in the background */
  closeExportModal(): void {
    this.showExportModal = false;
  }


  private isRunningStatus(status?: string): boolean {
    const s = (status || "").toUpperCase();
    return s !== "COMPLETED" && s !== "FAILED";
  }

  private startElapsedTimer(): void {
    this.stopElapsedTimer();
    this.updateElapsed();
    this.elapsedTimer = timer(1000, 1000).subscribe(() => this.updateElapsed());
  }

  private updateElapsed(): void {
    const sec = Math.floor((Date.now() - this.exportStartedAtMs) / 1000);
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    this.exportElapsed = `${m}m ${s.toString().padStart(2, "0")}s`;
  }

  private stopElapsedTimer(): void {
    this.elapsedTimer?.unsubscribe();
  }

  clearExport(): void {
    this.exportPoll?.unsubscribe();
    this.stopElapsedTimer();
    this.exportReport = null;
    this.exportError = "";
    this.exportElapsed = "";
    this.exportStarting = false;
    this.showExportModal = false;
  }

  ngOnDestroy(): void {
    this.exportPoll?.unsubscribe();
    this.elapsedTimer?.unsubscribe();
    this.searchSubscription?.unsubscribe();
    this.marketSearchSubscription?.unsubscribe();
  }
}